import {
	Dimensions,
	Text,
	Image,
	StatusBar,
	StyleSheet,
	View,
	SafeAreaView,
} from "react-native";
import React, { useEffect } from "react";
import { Button } from "react-native-paper";
import { OnBoardingScreenProps } from "./BoardingStack";
import { getPrimaryColor } from "../../utils/ColorsFunctions";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { TOKEN_STORAGE_KEY } from "../../store/api";
import { REFRESH_TOKEN_STORAGE_KEY } from "../../store/api";
import { AuthState, ALL_USER_INFO } from "../../store/slices/authSlice";
import { login } from "../../store/slices/authSlice";

const onBoardingBackground = require("../../../assets/images/onBoarding/ISIC-home-cover-app.png");

const OnBoarding = ({ navigation }: OnBoardingScreenProps) => {
	const dispatch = useAppDispatch();
	const user = useAppSelector(s => s.auth.subUser!);

	const handleLogin = async () => {
		navigation.navigate("AuthStack", {
			params: {
				screen: "Login",
			},
		});
	};

	const getSavedInfo = async () => {
		try {
			const allUserInfoStringified = await AsyncStorage.getItem(ALL_USER_INFO);
			const allUserInfo = JSON.parse(allUserInfoStringified!);
			const token = await AsyncStorage.getItem(TOKEN_STORAGE_KEY);
			const refreshToken = await AsyncStorage.getItem(
				REFRESH_TOKEN_STORAGE_KEY
			);

			let loggedUser: AuthState = {
				email: allUserInfo.email,
				userInfo: allUserInfo.user_info,
				token: token!,
				refreshToken: refreshToken!,
				auth: true,
			};

			if (allUserInfo.user_info.aggregate_users.length === 1) {
				dispatch(
					login({
						...loggedUser,
						subUser: allUserInfo.user_info.aggregate_users[0],
					})
				);
			} else {
				dispatch(login(loggedUser));
				navigation.navigate("AuthStack", { screen: "ChooseSubUser" });
			}
		} catch (error) {
			console.log("error on getSavedInfo");
		}
	};

	useEffect(() => {
		getSavedInfo();
	}, []);

	const goToTOS = () =>
		navigation.navigate("NewUserStack", { screen: "TermsOfService" });
	const goToPolicyPage = () => navigation.navigate("PolicyPageWebView");

	return (
		<SafeAreaView style={styles.root}>
			<StatusBar backgroundColor={getPrimaryColor(user)} />

			<Image
				source={onBoardingBackground}
				style={styles.background}
				resizeMode="stretch"
			/>
			<View style={styles.footer}>
				<Text style={styles.headerText}>Carteirinha do Estudante ISIC</Text>
				<Text style={styles.subText}>
					Benefícios exclusivos em produtos e serviços variados de
					estabelecimentos espalhados por todo o mundo.
				</Text>

				<Button
					style={[styles.btn]}
					labelStyle={styles.btnText}
					mode="contained"
					onPress={handleLogin}
				>
					Entrar
				</Button>
				<Text style={styles.text}>
					Não possui uma carteirinha ISIC?{" "}
					<Text
						style={[styles.linkText, { color: getPrimaryColor(user) }]}
						onPress={() => navigation.navigate("NewUserStack")}
					>
						Clique aqui
					</Text>
				</Text>
				<Text style={styles.text}>
					Ao se registrar, você concorda com nossos{" "}
					<Text
						style={[styles.linkText, { color: getPrimaryColor(user) }]}
						onPress={goToTOS}
					>
						Termos de Serviço
					</Text>{" "}
					e reconhece que nossa{" "}
					<Text
						style={[styles.linkText, { color: getPrimaryColor(user) }]}
						onPress={goToPolicyPage}
					>
						Política de Privacidade
					</Text>{" "}
					se aplica a você.
				</Text>
			</View>
		</SafeAreaView>
	);
};

export default OnBoarding;

const styles = StyleSheet.create({
	root: {
		flex: 1,
		position: "relative",
		backgroundColor: "#40b8b8",
	},
	background: {
		width: "100%",
		height: Dimensions.get("screen").height * 0.65,
		maxWidth: 800,
	},
	footer: {
		position: "absolute",
		bottom: 0,
		height: Dimensions.get("screen").height * 0.5,
		backgroundColor: "#f6f9fc",
		width: "100%",
		borderTopLeftRadius: 40,
		borderTopRightRadius: 40,
		paddingTop: 30,
		paddingHorizontal: 20,
	},
	headerText: {
		fontSize: 32,
		fontWeight: "bold",
		paddingBottom: 12,
		textAlign: "center",
		paddingHorizontal: 10,
	},
	subText: {
		fontSize: 15,
		lineHeight: 19,
		textAlign: "center",
		color: "rgb(153, 153, 153)",
	},
	btn: {
		marginTop: 40,
		marginBottom: 20,
		borderRadius: 25,
		alignSelf: "center",
		height: 50,
	},
	btnText: {
		color: "#fff",
		fontSize: 15,
		lineHeight: 30,
		width: "90%",
	},
	text: {
		textAlign: "center",
		color: "rgb(153, 153, 153)",
		marginBottom: 10,
	},
	linkText: { fontWeight: "700", textDecorationLine: "underline" },
});
